import React from "react";

interface ConnectorIconProps {
  className?: string;
  size?: number;
  color?: string;
  strokeWidth?: number;
}

/**
 * Connector Icon Component
 *
 * Two overlapping circles representing a connector/integration
 */
export function ConnectorIcon({
  className = "",
  size = 19,
  color = "currentColor",
  strokeWidth = 1.25,
}: ConnectorIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.66927 12.5007C9.89093 12.5007 12.5026 9.88898 12.5026 6.66732C12.5026 3.44566 9.89093 0.833984 6.66927 0.833984C3.44761 0.833984 0.835938 3.44566 0.835938 6.66732C0.835938 9.88898 3.44761 12.5007 6.66927 12.5007Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M11.6693 17.5007C14.8909 17.5007 17.5026 14.889 17.5026 11.6673C17.5026 8.44566 14.8909 5.83398 11.6693 5.83398C8.44761 5.83398 5.83594 8.44566 5.83594 11.6673C5.83594 14.889 8.44761 17.5007 11.6693 17.5007Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}
